import config from '../config/index'
import {
  CampaignPopup,
  CreateCampaignPopupParams,
  IPaginatedCampaignPopupFilterParams,
  PaginatedCampaignPopup,
} from '../pages/campaign-popups-container/share-type'
import { authRequest } from '../request'

const { mainApi } = config

export const getPaginatedCampaignPopups = (data: IPaginatedCampaignPopupFilterParams) =>
  authRequest.get<MISSING_TYPE, PaginatedCampaignPopup>(`${mainApi}/campaign-popups`, {
    params: data,
  })

export const createCampaignPopup = (data: CreateCampaignPopupParams): Promise<CampaignPopup> =>
  authRequest.post(`${mainApi}/campaign-popups`, data)

export const getCampaignPopupDetail = (campaignPopupId: number) =>
  authRequest.get(`${mainApi}/campaign-popups/${campaignPopupId}`)

export const editCampaignPopupDetail = (
  campaignPopupId: number,
  data: CreateCampaignPopupParams,
): Promise<CampaignPopup> => authRequest.put(`${mainApi}/campaign-popups/${campaignPopupId}`, data)

export const revokeCampaignPopup = (campaignPopupId: number) =>
  authRequest.delete(`${mainApi}/campaign-popups/${campaignPopupId}`)
